import { render, staticRenderFns } from "./ChampionshipOverview.vue?vue&type=template&id=34199ec3&scoped=true"
import script from "./ChampionshipOverview.vue?vue&type=script&lang=js"
export * from "./ChampionshipOverview.vue?vue&type=script&lang=js"
import style0 from "./ChampionshipOverview.vue?vue&type=style&index=0&id=34199ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34199ec3",
  null
  
)

export default component.exports